import React, {useState, useEffect} from 'react'
import ClaudeAiCustomDataJson from '../../whitaijiFrontendLibrary/components/ClaudeAiCustomDataJson';
import OpenAiCustomDataJson, { buildConcertSchema } from '../../whitaijiFrontendLibrary/components/OpenAiCustomDataJson';
import BlueButton from '../../components/BlueButton';
import { useStateContext } from '../../context/StateContext';
//import { songsData } from '../../data/songsData';
import * as pdfjsLib from 'pdfjs-dist';
import { getDocument } from 'pdfjs-dist/webpack';
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';
import T, { dT } from '../../components/Translation';
import VisDiv from '../../whitaijiFrontendLibrary/components/VisDiv';
import { useAuthContext } from '../../whitaijiFrontendLibrary/auth/hooks/useAuthContext';
import { AuthContext } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom'
import { blueColour, goldColour } from '../../pages/Home';
import { generateMongoDBId } from '../../whitaijiFrontendLibrary/lib/utils';
import TextField from '../../whitaijiFrontendLibrary/components/TextField';
import Swal from 'sweetalert2';
import Loading from '../../whitaijiFrontendLibrary/components/Loading';
import OpenAiTest from '../OpenAiTest';
import { successAlert } from '../../utils/utils';
import FieldDropdown from '../../whitaijiFrontendLibrary/components/FieldDropdown';
import TrueFalseToggle from '../../whitaijiFrontendLibrary/components/TrueFalseToggle';
import TestButton from '../TestButton';

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

const AiGeneratedConcert = ({data={}}) => {
    
    const navigate = useNavigate();
    const {hideTestButtons, language, emptyConcertDoc, rawAiConcert, setRawAiConcert, bookRemind, setBookRemind} = useStateContext()
    //const [bookRemind, setBookRemind] = useState([]);
    const [aiData, setAiData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [aiLoading, setAiLoading] = useState(false)
    const {user} = useAuthContext(AuthContext)
    const {concert, setConcert, emptyDoc, songsData, mindproUsers} = data
    const assignedUser = !Array.isArray(mindproUsers) ? [] : mindproUsers?.find((x) => x?.value === concert?.assignedToUserId)
    const [title, setTitle] = useState(concert?.title ? concert.title : "")
    const [assignedToUserId, setAssignedToUserId] = useState(assignedUser)
    const [assignedToAllMindproUsers, setAssignedToAllMindproUsers] = useState(concert?.assignedToAllMindproUsers ? concert.assignedToAllMindproUsers : false)
    const [description, setDescription] = useState(concert?.description ? concert.description : "")
    const [aiQuestion, setAiQuestion] = useState(concert?.aiQuestion ? concert.aiQuestion : "")
    const [aiJson, setAiJson] = useState() 
    const [nSongs, setNSongs] = useState(Number(concert?.nSongs) || 5)
    const [selectedAI, setSelectedAI] = useState("openai") // "openai" or "claude"

    const concertExists   = (concert?.title || concert?.songs?.length > 0) ? true : false

    const nSongsFn = (nSongsData) => {  
      const maxSongs = songsData?.length ? songsData?.length : 5
      const nSongs = Number(nSongsData)
      process.env.NODE_ENV === "development" && console.log("maxSongs", maxSongs, nSongs)
      if(!nSongs) {
        return 1
      } 
      if(nSongs > maxSongs) {
        return maxSongs
      }
      if(nSongs < 1) {
        return 1
      }
      return nSongs
    }

    // Randomly select AI on component mount
/*     useEffect(() => {
      setSelectedAI(Math.random() < 0.5 ? 'claude' : 'openai')
    }, []) */

    useEffect(() => {
        //process.env.NODE_ENV === "development" && console.log("concert useEffect", concert)
        setTitle(concert?.title ? concert.title : "")
        setAiQuestion(concert?.aiQuestion ? concert.aiQuestion : "")
        //setAiJson(concert ? concert : undefined)
        setDescription(concert?.description ? concert.description : "")
        setNSongs(Number(concert?.nSongs) || 1)
        setAssignedToUserId(concert?.assignedToAllMindproUsers ? null : assignedUser)
        setAssignedToAllMindproUsers(concert?.assignedToAllMindproUsers ? concert.assignedToAllMindproUsers : false)
    },[concert])

    useEffect(() => {
        if (aiJson) {
          try {
            let data;
            
            // Check if aiJson is already an object
            if (typeof aiJson === 'object' && aiJson !== null) {
              data = aiJson;
            } else if (typeof aiJson === 'string') {
              try {
                data = JSON.parse(aiJson);
              } catch (error) {
                process.env.NODE_ENV === "development" && console.error('Error parsing JSON string:', error);
                return;
              }
            } else {
              process.env.NODE_ENV === "development" && console.error('Invalid aiJson type:', typeof aiJson);
              return;
            }

            // Validate the data structure
            if (!data || typeof data !== 'object') {
              throw new Error('Invalid JSON structure: not an object');
            }

            if (!Array.isArray(data.songs) || data.songs.length === 0) {
              throw new Error('Invalid JSON structure: missing or empty songs array');
            }

            // If we got here, the data is valid
            process.env.NODE_ENV === "development" && console.log("Setting concert data:", data);
            setConcert({...concert, ...data});
          } catch (error) {
            process.env.NODE_ENV === "development" && console.error('Error processing AI response:', error);
            process.env.NODE_ENV === "development" && console.error('Error details:', error.message);
          }
        }
      }, [aiJson]);
      
    // New useEffect to handle rawAiConcert updates
 /*    useEffect(() => {
      // Skip if rawAiConcert is undefined or null
      if (!rawAiConcert) {
        return;
      }
      
      try {
        process.env.NODE_ENV === "development" && console.log("Processing rawAiConcert:", rawAiConcert);
        
        // Extract the raw response text
        const rawResponseText = rawAiConcert.rawResponse;
        
        if (!rawResponseText) {
          process.env.NODE_ENV === "development" && console.error('No raw response text found in rawAiConcert');
          return;
        }
        
        // Try to parse the JSON from the raw response
        let jsonContent;
        try {
          // First, check if the raw response is a Claude API response object
          const claudeResponse = JSON.parse(rawResponseText);
          
          // If it has a content array, extract the text from the first content item
          if (claudeResponse.content && Array.isArray(claudeResponse.content) && claudeResponse.content.length > 0) {
            process.env.NODE_ENV === "development" && console.log("Found Claude API response structure");
            
            // Extract the text content which contains our JSON
            const textContent = claudeResponse.content[0].text;
            process.env.NODE_ENV === "development" && console.log("Extracted text content:", textContent);
            
            // Parse the JSON from the text content
            jsonContent = JSON.parse(textContent);
          } else {
            // If it's not a Claude API response, try to find JSON in the raw response
            const jsonMatch = rawResponseText.match(/\{[\s\S]*\}/);
            if (jsonMatch) {
              jsonContent = JSON.parse(jsonMatch[0]);
            } else {
              // If no JSON object found, try parsing the whole response
              jsonContent = JSON.parse(rawResponseText);
            }
          }
          
          process.env.NODE_ENV === "development" && console.log("Successfully parsed JSON from raw response:", jsonContent);
        } catch (parseError) {
          process.env.NODE_ENV === "development" && console.error('Error parsing JSON from raw response:', parseError);
          process.env.NODE_ENV === "development" && console.log('Raw response content:', rawResponseText);
          return;
        }
        
        // Validate the parsed JSON structure
        if (!jsonContent || typeof jsonContent !== 'object') {
          process.env.NODE_ENV === "development" && console.error('Invalid JSON structure: not an object', jsonContent);
          return;
        }
        
        // Log the parsed JSON content for debugging
        process.env.NODE_ENV === "development" && console.log("Parsed JSON content:", jsonContent);
        
        // Check for required fields with more detailed logging
        const missingFields = [];
        if (!jsonContent.title) missingFields.push('title');
        if (!jsonContent.description) missingFields.push('description');
        if (!jsonContent.aiAnswer) missingFields.push('aiAnswer');
        
        if (missingFields.length > 0) {
          process.env.NODE_ENV === "development" && console.error(`Missing required fields in JSON response: ${missingFields.join(', ')}`);
          process.env.NODE_ENV === "development" && console.log("Available fields:", Object.keys(jsonContent));
        }
        
        // Ensure songs array exists and is valid, but don't return early
        if (!Array.isArray(jsonContent.songs)) {
          process.env.NODE_ENV === "development" && console.error('Invalid JSON structure: songs is not an array', jsonContent.songs);
          // Initialize an empty array if missing
          jsonContent.songs = [];
        } else if (jsonContent.songs.length === 0) {
          process.env.NODE_ENV === "development" && console.error('Invalid JSON structure: empty songs array');
        }
        
        // Less strict validation for songs - log issues but don't block processing
        jsonContent.songs.forEach((song, index) => {
          const missingSongFields = [];
          if (!song.songTemplateId) missingSongFields.push('songTemplateId');
          if (!song.title) missingSongFields.push('title');
          if (!song.affirmation) missingSongFields.push('affirmation');
          if (!song.aiDescription) missingSongFields.push('aiDescription');
          
          if (missingSongFields.length > 0) {
            process.env.NODE_ENV === "development" && console.error(`Song ${index} missing fields: ${missingSongFields.join(', ')}`, song);
          }
          
          // Check lyrics array
          if (!Array.isArray(song.lyrics)) {
            process.env.NODE_ENV === "development" && console.error(`Song ${index} lyrics is not an array`, song);
            song.lyrics = []; // Initialize empty array if missing
          } else if (song.lyrics.length === 0) {
            process.env.NODE_ENV === "development" && console.error(`Song ${index} has empty lyrics array`);
          }
        });
        
        // If we got here, the data is valid
        process.env.NODE_ENV === "development" && console.log("Setting concert data from rawAiConcert:", jsonContent);
        setConcert({...concert, ...jsonContent});
        
        // Update the UI fields
        setTitle(jsonContent.title || "");
        setDescription(jsonContent.description || "");
        setAiQuestion(jsonContent.aiQuestion || aiQuestion);
        
        // Clear rawAiConcert after successful processing
        setRawAiConcert(undefined);
        successAlert();
        
      } catch (error) {
        process.env.NODE_ENV === "development" && console.error('Error processing raw AI response:', error);
        process.env.NODE_ENV === "development" && console.error('Error details:', error.message);
      }
    }, [rawAiConcert]); */
  
    useEffect(() => {
      const loadRemindBookPdfContent = async ({setIsLoading, setBookRemind}) => {
        try {
          // Load the PDF file
          const response = await fetch('/aiReferenceDocs/reMind Book.pdf');
          const arrayBuffer = await response.arrayBuffer();
          
          // Load PDF document
          const loadingTask = getDocument({ data: arrayBuffer });
          const pdf = await loadingTask.promise;
          
          // Extract text from each page
          const textContent = [];
          for (let i = 1; i <= pdf?.numPages; i++) {
            const page = await pdf?.getPage(i);
            const content = await page?.getTextContent();
            const pageText = content?.items
              ?.map(item => item?.str)
              ?.join(' ')
              ?.trim();
            
            if (pageText) {
              textContent?.push(pageText);
            }
          }
          
          setBookRemind(textContent);
        } catch (error) {
          process.env.NODE_ENV === "development" && console.error('Error loading PDF:', error);
          setBookRemind(['Error loading PDF content']);
        } finally {
          setIsLoading(false);
        }
      };
      if(!bookRemind || bookRemind?.length < 0) loadRemindBookPdfContent({setIsLoading, setBookRemind});
      else setIsLoading(false);
    }, []);

  const responseSchema = buildConcertSchema(songsData);

  
  const aiPrompt = `
    CRITICAL RESPONSE REQUIREMENTS:
    1. Return ONLY a SINGLE JSON object
    2. Response MUST start with "{" and end with "}"
    3. NO text before or after the JSON
    4. NO explanations or additional responses
    5. NO markdown code blocks
    6. ALL properties must use double quotes
    7. NO trailing commas
    8. NO line breaks in string values
    9. DO NOT send any follow-up messages or explanations
    10. DO NOT wrap the JSON in code blocks
    11. MUST include exactly 5 songs in the songs array
   
    
    EXAMPLE VALID RESPONSE:
    {"title":"Concert Title","description":"Description here","songs":[{"title":"Song 1"}]}
    
    INVALID RESPONSE EXAMPLES:
    Here's your JSON: {"title":"Example"} // No text before/after
    \`\`\`json {"title":"Example"} \`\`\` // No markdown
    {"title":"Example"} Additional text // No extra text
    {"title":"Example"} \n Here's an explanation... // No follow-up text
    
    You are an accomplished psychologist.

    CRITICAL!!: The concert songs number must be exactly 5 songs in the songs array.
    Do not answer anything that is not related to mental health or personal development.
    Ensure your response is a valid JSON object that can be parsed.

    IMPORTANT!!: provided songsData:\n${JSON.stringify(songsData, null, 2)} 
    Give your answer in the language that the user is promping in.
    
    Analyze the user's input and respond with ONLY this JSON structure:
  
    {
      "title": "[generate a title for the concert based on the theme]",
      "description": "[short description of the concert theme]",
      "aiAnswer": "[your detailed response explaining how the songs and lyrics relate to the user's situation. If ${language} === 'it', write this in Italian but keep lyrics in English. If ${language} === 'en', write in English]",
      "aiQuestion": "[the user's question]",
      "songs": [
        {
          "songTemplateId": "[CRITICAL!!: strictly use the song _id from the songsData]",
          "title": "[CRITICAL!!: strictly use the song title from the songsData]",
          "order": 0,
          "affirmation": "[add a relatable famous quote (without adding the author as it will need to be recited) or create an affirmation related to the song, max 230 characters]",
          "aiDescription": "[briefly explain how this song relates to the user's situation]",
        }
      ]
    }

    `
  const openAiPrompt = `
    
    You are an accomplished psychologist.
.
    Do not answer anything that is not related to mental health or personal development.
    Ensure your response is a valid JSON object that can be parsed.

    IMPORTANT!!: provided songsData:\n${JSON.stringify(songsData, null, 2)} 
    CRITICAL!!: The concert songs number must be exactly 5 songs in the songs array
    
    For each song,  You are selecting a number of song lyrics that are most connected with the user's question, so that they can be highlighted for them
    to concentrate on while they listen.
    Select between 4 and 12 lyric objects per song in the following songsData, which are the songs in the concert
    Give your answer in the language that the user is promping in.
    `
    
    const consoleData = {mindproUsers, user, assignedToUserId, songsData, responseSchema}
    
    
    // Function to directly parse and set the concert from a valid JSON string
    const parseAndSetConcertFromJson = (jsonString) => {
      try {
        // Parse the JSON string
        const jsonContent = JSON.parse(jsonString);
        
        process.env.NODE_ENV === "development" && console.log("Manually parsing JSON content:", jsonContent);
        
        // Set the concert data
        setConcert({...concert, ...jsonContent});
        
        // Update the UI fields
        setTitle(jsonContent.title || "");
        setDescription(jsonContent.description || "");
        setAiQuestion(jsonContent.aiQuestion || aiQuestion);
        
        process.env.NODE_ENV === "development" && console.log("Successfully set concert data manually");
        return true;
      } catch (error) {
        process.env.NODE_ENV === "development" && console.error("Error manually parsing JSON:", error);
        return false;
      }
    }

    if(songsData.length < 1 || !songsData) return <Loading/>

    return (
    <>
      <div style={{padding: "5px"}}>
        <VisDiv VisDiv rules={[!aiLoading]} style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
            <TestButton buttonId='owkqpskqpowks' message='test concert' consoleData={consoleData}/> 
{/*             <BlueButton 
              hide={hideTestButtons} 
              text={"Parse Sample Response"} 
              fn={() => {
                // The sample JSON response from the user
                const sampleJson = `{
                  "title": "Transforming Morning Fatigue",
                  "description": "A therapeutic concert exploring emotional patterns and mindset shifts around morning energy and motivation",
                  "aiAnswer": "From the reference material and songs provided, your morning fatigue may be connected to deeper emotional patterns around perfectionism, anxiety, and resistance to change. The songs selected can help explore and transform these patterns that may be draining your morning energy. Through music, we can address potential underlying causes like setting unrealistic standards for yourself, anxiety about the day ahead, or resistance to embracing new routines. Let's use these songs to help shift your mindset and emotional relationship with mornings.",
                  "aiQuestion": "i feel tired in the morning",
                  "songs": [
                    {
                      "songTemplateId": "67d9608e92d990cfe4e09d78",
                      "title": "I Learn",
                      "order": 1,
                      "affirmation": "I am willing to learn and grow through this challenge, taking one small step at a time",
                      "aiDescription": "This song helps examine how perfectionist tendencies and fear of failure may be affecting your morning energy. It encourages embracing challenges as learning opportunities rather than sources of dread.",
                      "lyrics": [
                        {
                          "lyricTemplateId": "f080674cc2c3cec6454943e2",
                          "aiDescription": "This lyric acknowledges there are valuable lessons to be found in our struggles, including morning fatigue.",
                          "text": "I know there's a lesson here"
                        }
                      ]
                    },
                    {
                      "songTemplateId": "67d94b5e92d990cfe4e09c39",
                      "title": "What If",
                      "order": 2,
                      "affirmation": "I release anxiety about the day ahead and trust in my ability to handle whatever comes",
                      "aiDescription": "Addresses how morning anxiety and overthinking may be contributing to fatigue. Helps transform anxious 'what if' thoughts into empowering choices.",
                      "lyrics": [
                        {
                          "lyricTemplateId": "4a7d6f954d3afa445c60397a",
                          "aiDescription": "This lyric encourages letting go of anxiety and resistance that may be depleting morning energy.",
                          "text": "What If I could Let it go"
                        }
                      ]
                    },
                    {
                      "songTemplateId": "67ded696a5c7d05c2db991f0",
                      "title": "Conquer",
                      "order": 3,
                      "affirmation": "I approach each morning with renewed purpose and positive intention",
                      "aiDescription": "Helps build a more empowered mindset around mornings through manifestation and intention-setting practices.",
                      "lyrics": [
                        {
                          "lyricTemplateId": "f0f49c20b355d99ca4147bf4",
                          "aiDescription": "This lyric invites examining what we want to create with our days, starting with our morning energy.",
                          "text": "Making dreams come true"
                        }
                      ]
                    },
                    {
                      "songTemplateId": "67e28f46d0fe0c1f16d9cbb0",
                      "title": "Secondary Gain",
                      "order": 4,
                      "affirmation": "I choose to align my morning habits with my highest good and wellbeing",
                      "aiDescription": "Explores if there may be hidden benefits or patterns maintaining the morning fatigue that need to be acknowledged and transformed.",
                      "lyrics": [
                        {
                          "lyricTemplateId": "d0bd1986383cfaed41f3f584",
                          "aiDescription": "This lyric questions what we may be getting from maintaining patterns that don't serve us.",
                          "text": "What do I get in exchange for hurting"
                        }
                      ]
                    },
                    {
                      "songTemplateId": "67e28edcd0fe0c1f16d9cba6",
                      "title": "Mr Perfect",
                      "order": 5,
                      "affirmation": "I release the need to have perfect mornings and embrace my natural rhythms",
                      "aiDescription": "Addresses how perfectionism about morning routines may be creating unnecessary pressure and fatigue.",
                      "lyrics": [
                        {
                          "lyricTemplateId": "4767de9dae78c64e40cfc94e",
                          "aiDescription": "This lyric encourages taking small steps rather than expecting perfection.",
                          "text": "step by step"
                        }
                      ]
                    }
                  ]
                }`;
                
                parseAndSetConcertFromJson(sampleJson);
              }}
            /> */}
          {/*    <OpenAiTest /> */}
          </VisDiv>
          <VisDiv>
            <VisDiv rules={[!aiLoading]}>
              <div style={{padding: "1px"}}>
                <VisDiv rules={[!assignedToAllMindproUsers, mindproUsers?.length > 0]}>
                  <h3 style={{textAlign: 'left', marginBottom: user ? '0px' : '15px', marginTop: '15px'}}><T obj={{
                    it: "Assegna questo concerto ad un utente", 
                    en: "Assign concert to a user"
                  }}/>
                  </h3> 
                  <FieldDropdown
                    options={mindproUsers}
                    initialValue={assignedToUserId}
                    placeHolder= {dT({
                        en: "Select an user to assign",
                        it: "Seleziona un utente"}, language
                    )}
                    onChange={(value) =>  {
                      setAssignedToUserId(value)
                      setAssignedToAllMindproUsers(false)
                      setConcert({...concert, assignedToAllMindproUsers: false, assignedToUserId: value?.value})
                    }}
                  />
                </VisDiv>  

                <TrueFalseToggle
                  value={assignedToAllMindproUsers}
                  label={dT({en: "Assign to all my clients", it: "Assegna a tutti i miei client"}, language)}
                  onClick={() => {
                    setConcert({...concert, assignedToUserId: null, assignedToAllMindproUsers: !assignedToAllMindproUsers})
                    setAssignedToAllMindproUsers(!assignedToAllMindproUsers)
                    setAssignedToUserId(null)  
                    }}
                />
                <p>
                  <T obj={{
                    en:"Leave empty to post to yourself only",
                    it:"Lascia vuoto per pubblicare solo per te" 
                  }}/>
                </p>
              </div>
              <div style = {{display: "flex", flexDirection: "column", justifyContent: "center"}}>
                <h3 style={{textAlign: 'center', marginBottom: user ? '0px' : '15px', marginTop: '15px'}}><T obj={{
                  it: "Descrivimi come ti senti in dettaglio, l'intelligenza artificiale analizzerà il libro reMind e ti consiglierà la canzone da ascoltare e le parti del testo su cui concentrarti.", 
                  en: "Describe in detail how you feel, and ai will search the reMind book to recommend a song to listen to and the lyrics to focus on."
                }}/></h3>
              </div>  
              {!user?.isSubscribed &&  <div style = {{display: "flex", flexDirection: "column", justifyContent: "center"}}>
                <p style={{textAlign: 'center', marginBottom: user ? '0px' : '15px', marginTop: '15px'}}>
                  <T obj={{
                    it: "Iscrivendoti e abbonandoti a reMind, potrai salvare il risultato nel tuo dashboard.", 
                    en: "By signing up and subscribing to reMind, you will be able to save the result in your dashboard."
                  }}/>
                  <T obj={{
                  it: ` Non essendo ancora iscritto, IA prende in considerazione solo i capitoli del libro reMind e le canzoni "What if" sull'ansia, "Mr Perfect" sul perfezionismo
                  ed "As far as it takes" sul lutto e tristezza. `, 
                  en: ` As you are not yet subscribed, the AI only considers the chapters from the reMind book and the songs "What if" about anxiety, "Mr Perfect" about perfectionism,
                  and "As Far As It Takes" about grief and sadness.`,
                  
                }}/></p>
                </div> }
                <div style={{marginTop:"20px", marginBottom:"20px"}}>
                    <textarea 
                        className="text-area-input"
                        onChange={(e) => setAiQuestion(e.target.value)}
                        value={aiQuestion}
                        onBlur={() => setConcert({...concert, aiQuestion: aiQuestion})}
                    />
                </div>
                  {/* <div style={{marginBottom:"20px"}}>
                    <h3><T obj={{en: "How Many Songs Would You Like In Your Concert?", it: "Quante canzoni desideri nel tuo concerto?"}}/></h3>
                </div>
                <TextField 
                    style = {{width:"110px"}}
                    onChange={(e) => setNSongs(e.target.value)}
                    value={nSongs}
                    onBlur={() => setConcert({...concert, nSongs: nSongsFn(nSongs)})}
                /> */}
            </VisDiv>
            {isLoading ? (
              <T obj={{
                it: "Carico il libro reMind...", 
                en: "Loading the reMind book..."
              }}/>
            ) : selectedAI === 'claude' ? (
              <ClaudeAiCustomDataJson 
                dataExists = {concertExists}
                placeholder = 
                      { language === "en" ? "Tell me how you feel in detail... (Press Enter to send, Shift+Enter for new line" :  
                      "Descrivimi come ti senti in dettaglio... (Premi Invio per spedire, Shift+Invio per andare a capo"
                    }
                customData={bookRemind} 
                systemPrompt={aiPrompt} 
                strict={true}
                responseExamples = {false}
                aiQuestion = {aiQuestion}
                setAiJson={setAiJson}
                alertTitle = {dT({ en: `A Concert Already Exists: ${concert?.title ? concert.title : ""}`, it:`Esiste Già Un Concerto: ${concert?.title ? concert.title : ""}`},language)}
                alertText = {dT({ en: `Do you want to overwrite it? The concert can't be undone!`, it:`Vuoi sovrascriverlo? Il concerto non potrà essere ripristinato! `}, language)}
                loadingCallback={setAiLoading}
              />
            ) : (
              <OpenAiCustomDataJson 
                dataExists = {concertExists}
                placeholder = 
                      { language === "en" ? "Tell me how you feel in detail... (Press Enter to send, Shift+Enter for new line" :  
                      "Descrivimi come ti senti in dettaglio... (Premi Invio per spedire, Shift+Invio per andare a capo"
                    }
                //customData={bookRemind} 
                jsonSchema={responseSchema}
                systemPrompt={openAiPrompt} 
                strict={false}
                maxNTokens = {true}
                //model = {"gpt-4.1"}
                responseExamples = {false}
                aiQuestion = {aiQuestion}
                setAiJson={setAiJson}
                alertTitle = {dT({ en: `A Concert Already Exists: ${concert?.title ? concert.title : ""}`, it:`Esiste Già Un Concerto: ${concert?.title ? concert.title : ""}`},language)}
                alertText = {dT({ en: `Do you want to overwrite it? The concert can't be undone!`, it:`Vuoi sovrascriverlo? Il concerto non potrà essere ripristinato! `}, language)}
              />
            )}
            <VisDiv rules={[!aiLoading]}>
              <div style={{marginBottom:"20px", marginTop:"20px"}}>
                  <h3><T obj={{en: "Concert Title", it: "Titolo Concerto"}}/></h3>
              </div>
              <TextField 
                  onChange={(e) => setTitle(e.target.value)}
                  value={title}
                  onBlur={() => setConcert({...concert, title})}
              />
              <div style={{marginBottom:"20px"}}>
                  <div style={{marginBottom:"20px"}}>
                      <h3><T obj={{en: "Brief Description", it: "Breve Descrizione"}}/></h3>
                  </div>
                  <textarea 
                      className="text-area-input"
                      onChange={(e) => setDescription(e.target.value)}
                      value={description}
                      onBlur={() => setConcert({...concert, description: description})}
                  />
              </div>
              <VisDiv rules={[concert?.aiAnswer]}>
                <h3 style={{marginBottom:"20px"}}><T obj={{en: "Ai Response", it: "Risposta dell'IA"}}/></h3>
                <p>{concert?.aiAnswer}</p>
              </VisDiv>

              {/* Display raw AI response for debugging */}
              <VisDiv rules={[false]}>
                <h3 style={{marginBottom:"20px", color: "red"}}>Raw AI Response (Debug)</h3>
                <div style={{
                  backgroundColor: "#f5f5f5", 
                  padding: "10px", 
                  borderRadius: "5px",
                  border: "1px solid #ddd",
                  overflow: "auto",
                  maxHeight: "500px"
                }}>
                  <pre>{JSON.stringify(rawAiConcert, null, 2)}</pre>
                </div>
                
                {rawAiConcert?.rawResponse && (
                  <div>
                    <h4 style={{marginTop:"20px", marginBottom:"10px", color: "red"}}>Raw Response Content</h4>
                    <div style={{
                      backgroundColor: "#f5f5f5", 
                      padding: "10px", 
                      borderRadius: "5px",
                      border: "1px solid #ddd",
                      overflow: "auto",
                      maxHeight: "500px"
                    }}>
                      <pre>{rawAiConcert.rawResponse}</pre>
                    </div>
                  </div>
                )}
              </VisDiv>
            </VisDiv>

        </VisDiv>
      </div>
    </>
    )
  }
  

export default AiGeneratedConcert
